import * as yup from 'yup';

export const schemaFormTela = yup
  .object({
    des_tela: yup.string().required(),
    cod_modulo: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_modulo_secao: yup.object().when('cod_modulo', {
      is: (cod_modulo: { value?: number } | null) =>
        !!cod_modulo && typeof cod_modulo.value === 'number',
      then: (schema) =>
        schema.shape({
          label: yup.string().required(),
          value: yup.number().required(),
        }),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    des_funcao: yup.string().required(),
    label_menu: yup.string().required(),
    des_label_novo: yup.string().required(),
    lib_icon: yup.object().shape({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
    des_icon: yup.object().when('lib_icon', {
      is: (lib_icon: { value?: string } | null) =>
        !!lib_icon &&
        typeof lib_icon.value === 'string' &&
        lib_icon.value !== '',
      then: (schema) =>
        schema.shape({
          label: yup.string().required(),
          value: yup.string().required(),
        }),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  })
  .required();

export const schemaFormCampo = yup
  .object({
    des_campo: yup.string().required(),
    nome_bd: yup
      .string()
      .required()
      .matches(/(^t\.)\w+/, {
        message: `Este campo deve se iniciar no padrão "t.[nome_campo]"`,
      }),
    cod_tipo_dados: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();
